/*
 * pic-nn-web-ui
 *
 * Web UI for neural network applications.
 *
 * @copyright 2020 VSTE CB <http://www.vstecb.cz/>.
 * @license See LICENSE file distributed with this source code for more information.
 */

/**
 * Formats numerical value to specified decimals with optional multiply operation
 *
 * @param value Value
 * @param decimals Decimal count
 * @param multiplier Multiplier
 * @param decimalSeparator Custom decimals separator
 */
export function formatNumericValue(value: number, decimals?: number, multiplier?: number, decimalSeparator?: string) {

	let val: string;

	if (isNaN(value) || !isFinite(value)) {
		val = "-";
	} else if (decimals) {
		val = (value * (multiplier || 1)).toFixed(decimals);
	} else {
		val = String(value * (multiplier || 1));
	}

	if (decimalSeparator) {
		val = val.replace(".", decimalSeparator);
	}

	return val;

}

/**
 * Converts some characters to dashes
 *
 * @param name Name
 */
export function sanitizeName(name: string) {

	return name
		.replace(/[-,\. \/]/g, "-")
		.replace(/---*/g, "-")
		.replace(/-$/, "");

}
